//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action$Type } from '../genericFlowTypes'

const initialState:ReducerState$Type = {
    error: '',
    invoiceSubmitted: false,
    resultset: null,
    anyChanges: false,
    formData: {},
    reviewQuestions: [],
    formError: {},
    vendors: [],
    vendorsLoaded: false,
    depositAccounts: [],
    depositAccountsLoaded: false
}

//In use : actionTypes.THEIA_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: ''
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const updateFormError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const refreshedVendors=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        vendors: action.vendors,
        vendorsLoaded: true
    }
}

const headerActionsError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: action.error
    }
}

const refreshedDepositAccounts=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        depositAccounts: action.depositAccounts,
        depositAccountsLoaded: true
    }
}

export default reduce(initialState,{
    [actionTypes.THEIA_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.THEIA_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.THEIA_INV_SUBMIT_ERROR]: headerActionsError,
    [actionTypes.THEIA_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.THEIA_EDIT_VERIFY_FORM_DATA_ERROR]: headerActionsError,
    [actionTypes.THEIA_UPDATE_FORM_ERROR]: updateFormError,
    [actionTypes.REFRESH_THEIA_VENDORS_SUCCESS]: refreshedVendors,
    [actionTypes.REFRESH_THEIA_VENDORS_ERROR]: headerActionsError,
    [actionTypes.REFRESH_THEIA_DEPOSIT_ACCOUNTS_SUCCESS]: refreshedDepositAccounts,
    [actionTypes.REFRESH_THEIA_DEPOSIT_ACCOUNTS_ERROR]: headerActionsError
});


// WEBPACK FOOTER //
// ./src/redux/theia/reducer.js